// extracted by mini-css-extract-plugin
export default {"barra":"PremiumTopBar_barra__tOc0K","botao":"PremiumTopBar_botao__myXcB","vazio":"PremiumTopBar_vazio__Unuhd","selo":"PremiumTopBar_selo__Mjyaj"};